"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentCCSubappLoader = void 0;
const initializer_1 = require("../../initializer");
const subappDevelopmentBaseLoader_1 = require("../subappDevelopmentBaseLoader");
const contactCenter_1 = require("../../contactCenter");
/**
 * Wraps the app in the providers and mounts it directly into the DOM
 */
const developmentCCSubappLoader = async (params) => {
    if ((0, contactCenter_1.isDRPicasoRoute)()) {
        await initializer_1.DRPicasoAuthenticator.loginAgent();
    }
    else if (!(0, contactCenter_1.isDevelopmentLogicCCRoute)()) {
        if (!initializer_1.CCDevSession.isValid() && !initializer_1.DRPicasoSession.isValid()) {
            await initializer_1.USDAuthenticator.login();
        }
    }
    await (0, subappDevelopmentBaseLoader_1.developmentSubappBaseFeatureLoader)(params);
    (0, subappDevelopmentBaseLoader_1.developmentSubappBaseRender)(params);
};
exports.developmentCCSubappLoader = developmentCCSubappLoader;
//# sourceMappingURL=index.js.map